import { getConfigValue } from './runtimeConfig.js';

export const APP_NAME = getConfigValue('VITE_APP_NAME') ?? 'App';

export const APP_TITLE = `Search Ads Report - ${APP_NAME}`;
